export const state = {
    delete_filter_status: false,
};